<template>
	<div style="width: 100%">
		<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="所属门店：">
				<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品类型：">
				<el-select v-model="formInline.typeName" placeholder="请选择商品类型" clearable filterable size="small" @change="handleTypeNameChange">
					<el-option v-for="item in typeNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品系列：">
				<el-select v-model="formInline.productName" placeholder="请选择商品系列" clearable filterable size="small" @change="inputChange">
					<el-option v-for="item in productNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品名称：">
				<el-input v-model="formInline.specification" placeholder="请输入商品名称" clearable size="small" @change="inputChange"></el-input>
			</el-form-item>
			<el-form-item label="操作时间：">
				<el-date-picker
					v-model="dateRange"
					size="small"
					type="daterange"
					value-format="yyyy-MM-dd"
					format="yyyy-MM-dd"
					range-separator="~"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					clearable
					@change="handleDateChange"
				></el-date-picker>
			</el-form-item>
			</lcsj-filter>
		<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData"></STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import { GetProductTypeNameList, GetProductTypeSubNameList, GetStoreProductQtyEditHistoryPageList } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				typeName: "",
				productName: "",
				specification: "",
				createTimeStart: null,
				createTimeEnd: null
			},
			dateRange: null,
			storeList: [],
			typeNameList: [],
			productNameList: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					align: "center"
				},
				{
					prop: "productInfo.code",
					label: "商品编码",
					align: "center"
				},
				{
					prop: "productInfo.typeName",
					label: "类型",
					align: "center"
				},
				{
					prop: "productInfo.productName",
					label: "系列",
					align: "center"
				},
				{
					prop: "productInfo.specification",
					label: "商品名称",
					align: "center"
				},
				{
					prop: "productInfo.unit",
					label: "单位",
					align: "center"
				},
				{
					prop: "yuanQuantity",
					label: "原数量",
					align: "center"
				},
				{
					prop: "xianQuantity",
					label: "修改后数量",
					align: "center"
				},
				{
					prop: "creator",
					label: "操作人",
					align: "center"
				},
				{
					prop: "createTime",
					label: "操作时间",
					align: "center"
				}
			]
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		this.getProductTypeNameList();
		// 商品系列默认取全量，选择商品类型后按类型联动
		this.getProductTypeSubNameList("");
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					this.storeList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取商品类型名称列表
		getProductTypeNameList() {
			GetProductTypeNameList({}).then((res) => {
				if (res.code == 1) {
					this.typeNameList = [];
					res.data.forEach((item) => {
						this.typeNameList.push({
							keyId: item.value,
							value: item.value
						});
					});
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 处理商品类型改变（清空并联动商品系列）
		handleTypeNameChange(val) {
			this.formInline.productName = "";
			this.getProductTypeSubNameList(val);
			this.search();
		},
		// 获取商品系列列表（传商品类型时按类型联动，传空取全量）
		getProductTypeSubNameList(code) {
			GetProductTypeSubNameList({ code: code }).then((res) => {
				if (res.code == 1) {
					this.productNameList = [];
					res.data.forEach((item) => {
						this.productNameList.push({
							keyId: item.value,
							value: item.value
						});
					});
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 操作时间范围（清空时归一化为 null，避免后端非可空类型反序列化失败）
		handleDateChange(value) {
			if (value && value.length === 2) {
				this.formInline.createTimeStart = value[0];
				this.formInline.createTimeEnd = value[1];
			} else {
				this.formInline.createTimeStart = null;
				this.formInline.createTimeEnd = null;
			}
			this.search();
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetStoreProductQtyEditHistoryPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.dateRange = null;
			// 重置后商品系列恢复全量
			this.getProductTypeSubNameList("");
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		}
	}
};
</script>

<style scoped></style>
